import { useEffect, useState } from "react";
import About from "./pages/About";
import Banking from "./pages/Banking";
import Career from "./pages/Career";
import Company from "./pages/Company";
import Cookies from "./pages/Cookies";
import Grievance from "./pages/Grievance";
import Home from "./pages/Home";
import InformationSecurityPolicy from "./pages/InformationSecurityPolicy";
import InterestRatePolicy from "./pages/InterestRatePolicy";
import KycAmlPolicy from "./pages/KycAmlPolicy";
import Login from "./pages/Login";
import Locate from "./pages/Locate";
import Media from "./pages/Media";
import MediaPolicy from "./pages/MediaPolicy";
import Policies from "./pages/Policies";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Retail from "./pages/Retail";
import RefundCancellationPolicy from "./pages/RefundCancellationPolicy";
import RiskManagementPolicy from "./pages/RiskManagementPolicy";
import Services from "./pages/Services";
import SocialMediaPolicy from "./pages/SocialMediaPolicy";
import Software from "./pages/Software";
import Terms from "./pages/Terms";

function getRouteFromHash() {
  const hash = window.location.hash.toLowerCase().replace(/\/+$/, "");
  if (hash === "#/banking" || hash.startsWith("#/banking?")) return "banking";
  if (hash === "#/retail" || hash.startsWith("#/retail?")) return "retail";
  if (hash === "#/services" || hash.startsWith("#/services?")) return "services";
  if (hash === "#/software" || hash.startsWith("#/software?")) return "software";
  if (hash === "#/locate" || hash.startsWith("#/locate?")) return "locate";
  if (hash === "#/login" || hash.startsWith("#/login?")) return "login";
  if (hash === "#/about" || hash.startsWith("#/about?")) return "about";
  if (hash === "#/career" || hash.startsWith("#/career?")) return "career";
  if (hash === "#/policies" || hash.startsWith("#/policies?")) return "policies";
  if (hash === "#/privacy-policy" || hash.startsWith("#/privacy-policy?"))
    return "privacyPolicy";
  if (hash === "#/cookies-policy" || hash.startsWith("#/cookies-policy?"))
    return "cookiesPolicy";
  if (
    hash === "#/grievance-policy" ||
    hash.startsWith("#/grievance-policy?")
  )
    return "grievancePolicy";
  if (
    hash === "#/terms-and-conditions" ||
    hash.startsWith("#/terms-and-conditions?")
  )
    return "termsConditions";
  if (
    hash === "#/interest-rate-policy" ||
    hash.startsWith("#/interest-rate-policy?")
  )
    return "interestRatePolicy";
  if (
    hash === "#/info-policy" ||
    hash.startsWith("#/info-policy?") ||
    hash === "#/information-security-policy" ||
    hash.startsWith("#/information-security-policy?")
  )
    return "informationSecurityPolicy";
  if (
    hash === "#/kyc-policy" ||
    hash.startsWith("#/kyc-policy?") ||
    hash === "#/kyc-aml-policy" ||
    hash.startsWith("#/kyc-aml-policy?")
  )
    return "kycAmlPolicy";
  if (hash === "#/media" || hash.startsWith("#/media?")) return "media";
  if (hash === "#/media-policy" || hash.startsWith("#/media-policy?"))
    return "mediaPolicy";
  if (
    hash === "#/social" ||
    hash.startsWith("#/social?") ||
    hash === "#/social-media-policy" ||
    hash.startsWith("#/social-media-policy?") ||
    hash.includes("social-media") ||
    hash.includes("social")
  )
    return "socialMediaPolicy";
  if (
    hash === "#/risk" ||
    hash.startsWith("#/risk?") ||
    hash === "#/risk-management-policy" ||
    hash.startsWith("#/risk-management-policy?")
  )
    return "riskManagementPolicy";
  if (
    hash === "#/refund" ||
    hash.startsWith("#/refund?") ||
    hash === "#/refund-policy" ||
    hash.startsWith("#/refund-policy?") ||
    hash === "#/refund-cancellation-policy" ||
    hash.startsWith("#/refund-cancellation-policy?") ||
    hash.includes("refund-policy") ||
    hash.includes("refund-cancellation") ||
    hash.includes("refund")
  )
    return "refundCancellationPolicy";
  if (hash === "#/company" || hash.startsWith("#/company?")) return "company";
  return "home";
}

function App() {
  const [route, setRoute] = useState(getRouteFromHash());

  useEffect(() => {
    const onHashChange = () => setRoute(getRouteFromHash());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [route]);

  if (route === "banking") return <Banking />;
  if (route === "retail") return <Retail />;
  if (route === "services") return <Services />;
  if (route === "software") return <Software />;
  if (route === "login") return <Login />;
  if (route === "about") return <About />;
  if (route === "career") return <Career />;
  if (route === "policies") return <Policies />;
  if (route === "privacyPolicy") return <PrivacyPolicy />;
  if (route === "cookiesPolicy") return <Cookies />;
  if (route === "grievancePolicy") return <Grievance />;
  if (route === "termsConditions") return <Terms />;
  if (route === "interestRatePolicy") return <InterestRatePolicy />;
  if (route === "informationSecurityPolicy")
    return <InformationSecurityPolicy />;
  if (route === "kycAmlPolicy") return <KycAmlPolicy />;
  if (route === "mediaPolicy") return <MediaPolicy />;
  if (route === "socialMediaPolicy") return <SocialMediaPolicy />;
  if (route === "riskManagementPolicy") return <RiskManagementPolicy />;
  if (route === "refundCancellationPolicy") return <RefundCancellationPolicy />;
  if (route === "company") return <Company />;
  if (route === "locate") return <Locate />;
  if (route === "media") return <Media />;

  return <Home />;
}

export default App;
